<div class="insurance-dashboard">
    <header class="dashboard-header">
        <div>
            <span>Insurance advisory</span>
            <h1>Insurance Reports</h1>
            <p>Create a lightweight photo-and-description report for client insurance records.</p>
        </div>
    </header>

    <section class="create-panel">
        <div class="create-fields">
            <label>
                <span>Owner name</span>
                <input [ngModel]="ownerName()" (ngModelChange)="ownerName.set($event)" placeholder="Owner or customer name">
            </label>
            <label>
                <span>Address</span>
                <input [ngModel]="address()" (ngModelChange)="address.set($event)" placeholder="Property address">
            </label>
            <label>
                <span>Email optional</span>
                <input type="email" [ngModel]="customerEmail()" (ngModelChange)="customerEmail.set($event)" placeholder="customer@example.com">
            </label>
        </div>
        <button class="btn-primary" type="button" (click)="createReport()" [disabled]="isCreating()">
            {{ isCreating() ? 'Creating...' : 'Create Report' }}
        </button>
    </section>

    <section class="reports-section">
        <div class="section-heading">
            <h2>Saved Reports</h2>
            <span>{{ reports().length }} records</span>
        </div>

        <div class="reports-grid" *ngIf="!isLoading(); else loadingState">
            <article class="report-card" *ngFor="let report of reports()" (click)="openReport(report)">
                <div class="card-top">
                    <span class="status">{{ report.status }}</span>
                    <span class="attached">{{ attachedLabel(report) }}</span>
                </div>
                <h3>{{ report.report_no }}</h3>
                <p>{{ report.customer_name || 'Untitled owner' }}</p>
                <p class="address">{{ report.site_address || 'No address added' }}</p>
                <div class="card-bottom">
                    <small>{{ report.item_count || 0 }} image items</small>
                    <small>{{ formatDate(report.updated_at || report.created_at) }}</small>
                </div>
                <div class="card-actions">
                    <button type="button" class="btn-open" (click)="openReport(report); $event.stopPropagation()">Open Editor</button>
                    <button type="button" class="btn-delete" (click)="deleteReport(report, $event)">Delete</button>
                </div>
                <small class="sent-label" *ngIf="report.emailed_at">Last emailed {{ formatDate(report.emailed_at) }}</small>
            </article>
            <div class="empty-state" *ngIf="reports().length === 0">No insurance reports yet.</div>
        </div>

        <ng-template #loadingState>
            <div class="empty-state">Loading reports...</div>
        </ng-template>
    </section>
</div>
